import {CA} from '../../shared/scripts/analytics/Analytics.ts'
import {StorageWrapper} from '../../shared/scripts/StorageWrapper.ts'
import {ClientUserState} from '../../shared/scripts/ClientUserState.ts'
import {setElementOnClick} from '../../shared/scripts/ui_utils/DomUtils.ts'
import {PushNotificationPopupIntentEnum, UIMRequestPushNotificationController} from './notifications/UIMRequestPushNotificationController.ts'

export class UIMLoginController {
    private readonly loginButtons: HTMLElement[]
    private readonly guestLogin: HTMLLinkElement

    constructor() {
        this.loginButtons = Array.from(document.getElementsByClassName('popup-login-btn')) as HTMLElement[]
        this.guestLogin = document.getElementById('continue-as-guest') as HTMLLinkElement

        this.loginButtons.forEach((btn) => {
            if(btn == null) return
            // eslint-disable-next-line no-restricted-syntax
            btn.addEventListener('click', () => {
                btn.classList.add('loading')

                setTimeout(() => {
                    this.removeLoading()
                }, 7500)
            })
        })

        this.handleUserLoginFlow()

        const bypassLogin = () => {
            StorageWrapper.setUserBypassedLogin(true)
            this.handleUserLoginFlow()
        }

        setElementOnClick(this.guestLogin, bypassLogin)
    }

    removeLoading() {
        this.loginButtons.forEach((btn) => {
            if(btn == null) return
            btn.classList.remove('loading')
        })
    }

    // eslint-disable-next-line class-methods-use-this
    private handleUserLoginFlow() {
        const loginContainer = document.getElementById('login-container') as HTMLDivElement

        const shouldShowLoginScreen = !ClientUserState.userState?.isLoggedIn && !StorageWrapper.getIfUserBypassedLogin()

        if(shouldShowLoginScreen) {
            loginContainer.style.display = ''
            // eslint-disable-next-line no-restricted-syntax
            this.loginButtons.forEach((loginButton) => loginButton.addEventListener('click', () => CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)))
        } else {
            loginContainer.style.display = 'none'
            UIMRequestPushNotificationController.showRequestPushNotification(PushNotificationPopupIntentEnum.OnLoadHomePage)
        }
    }
}
